// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template :style="[
  { backgroundImage: 'url(http://alpha.gixcore.com/img/sep09.jpg)' }]">
  <div id="app">
    <div :class="{'darken': darken}"></div>
    <div class="navbar-component">
      <navbar />
    </div>
    <div v-if="getHome($route.name)">
      <AppHome />
    </div>
    <div v-else>
      <!-- <navbar2 /> -->
      <div class="main-container container">
        <BuilderRouter/>      
        <RecentBuilds />
      </div>
    </div>
      <Footer />
      <!-- <footer class="footer">footer</footer> -->
  </div>
</template>

<script>
import                              'es6-promise/auto'
import navbar                 from  './components/navbar.vue'
import { mapActions, mapGetters }         from  'vuex'
import BuilderRouter          from  './components/builder/BuilderRouter.vue'
import AppHome                from  './components/AppHome.vue'
import RecentBuilds           from  './components/RecentBuilds.vue'
import Footer                 from './components/Footer.vue'
import {EventBus}               from './eventBus'

export default {
  name: 'app',
  components: {
    BuilderRouter,
    RecentBuilds,
    navbar,
    AppHome,
    Footer
  },

  data() {
    return {
      cart: {},
      startLoadTime: 0,
      darken: false,
    }
  },
  mounted(){
    EventBus.$on('extended', (bool) => {
      this.darken = bool
    })
  },
  beforeMount(){
    this.startLoadTime = performance.now()
  },
  watch: {
    loggedIn(){},
  },
  methods: {
    ...mapActions([
      'fetchMiningProfitability',
      'unsetItem'
    ]),
    getHome(route){
      console.log('current route: ', route)
      if(route == 'AppHome'){
  
        return true
      }
      else return false
    },
  },
  props: ["menu"],
  computed: mapGetters([
    'allProcessors',
    'loggedIn'
  ]),
  created(){
    // this.fetchMiningProfitability()
    console.log('APP LOADED IN ', ((performance.now() - this.startLoadTime)/1000).toFixed(2), ' seconds')
  },
  destroyed(){
    this.unsetItem()
  }
}

</script>

<style>
::-webkit-scrollbar { 
   display: none; 
}
/* @import 'assets/css/bootstrap.min.css'; */
@import 'assets/css/custom.css';
@import 'assets/css/toolkit-inverse.css';
html {
  background-color: #191b20 !important;
}
.darken {
  
  position: fixed;
  right: 0px;
  left: 0px;
  top: 0px;
  bottom: 0px;
  background: #191B20;
  opacity: 0.7;
  z-index: 10;
  transition: 0.3s;
  
}
body {
  letter-spacing: 0.1px;
  background-color: #191b20;
  min-width: 340px;
  padding-top: 8px;
  padding-bottom: 0px;
  padding-left: 1%;
  padding-right: 1%;
  /* min-width: 963px; */
}
.bg-dark {
  background-color: #191b20 !important;
  opacity: 0.9;
}
.cart-btn a{
  color: white;
}
.header {
  padding:10px;
      padding-left: 0px;
    padding-right: 0px;

  /* border: 1px solid #434857; */
  /* border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px; */
  /* background-color: #1997c6; */
    /* box-shadow: inset 0px -4px 5px 0px #434857; */
}
.gixcore-dropdown {
    padding-top: 2px;
    margin-right: 16px;
    vertical-align: top;
    background-color: rgb(25, 27, 32) !important;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 6px;
}
.info-container {
  display: contents;
}
.footer {
  position: absolute;
  bottom: 0px;
}
.item-list {
  margin-right: -8px;
}
.list-title-mob {
  display: none;
}
@media screen and (max-width: 1200px){
  body {
    padding: 0px;
  }
  .main-container {
    padding-left: 0px;
  }
  .searchbar-section {
    /* position: fixed; */
  }
  .item-list {
    height: unset;
    padding-right: 0px;
    overflow: hidden;
    margin-right:0px;
  }
}
@media screen and (max-width: 1000px){
  body {
    font-size: 14px;
  }
  .item-list {
    height: unset;
    padding-right: 0px;
  }
  .small-bullet.value {
    font-size: 14px !important;
  }
  .small-bullet.value {
    font-size: 14px !important;
  }
  .extend-list-button {
    display: none;
  }
  .gixcore-dropdown {
    margin-right: 0px;
  }
  .list-title {
    font-size: 20px;
    height: 28px !important;
  }
  .price li {
    font-size: 20px;
  }
  .tip {
    padding: 3px;
  }
  .demo .img-list {
    height: 105px !important;
    min-width: 105px !important;
  }
  .gc-button {
    height: 32px !important;
    font-size: 18px !important;
  }
  .clone-button {
    padding-top: 3px !important;
    font-size: 16px !important;
  }
}
@media screen and (max-width: 863px){
  .tip {
    min-width: 85px !important;
  }
  .item-desc {
    max-width: 39vw !important;
    white-space: unset !important;
        max-height: 67px;
  }
  .tips-mob {
    display: flex !important;
    margin-top: 4px !important;
    margin-bottom: 0px;
  }
  .tip:last-child {
    margin-right: 2px !important;
  }
  .list-title {
    overflow: hidden;
  }
  li.item.title {
    overflow: hidden !important;
  }
}
@media screen and (max-width: 584px){
  .collapsed-price {
    justify-content: right !important;
    padding-right: 15px !important;
  }
  .header {
    padding-left: 10px;
    padding-right: 10px;
  }
  .page-router-component{
    display: none !important;
  }
  .builds-container {
    padding-left: 15px !important;
  }
  .build-item {
    width: 100% !important;
  }
  .extended {
    width: 100% !important
  }
  .menu-optoins-buttons .gc-button{
    height: 32px !important
  }
  .collapsed-menu-component {
    display: block;
    position: relative !important;
    width: 100% !important;
    max-height: 100vh !important;
  }
  .list-title-mob {
    display: block;
    margin-top: -8px;
    margin-left: 3px;
    margin-bottom: 6px;
  }
  .tip {
    min-width: 85px !important;
    display: inline-block !important;
    justify-content: space-between;
    /* margin-right: 0px !important; */
    /* border: none !important; */
    /* border-bottom: 1px solid #434857 !important; */
    /* border-radius: 0px !important; */
  }
  .info-container {
    display: block;
    width: 100%;
  }
  .price li {
    text-align: right;
  }
  .list-buttons {
    padding-left: 8px;
        text-align: right;

  }
  .item.title {
    
  }
  .info-list {}
  /* .item.item-desc {
    display: none !important;
  }  */
  .tips-mob {
    display: flex !important;
    margin-top: 4px !important;
    margin-bottom: 0px;
    max-height: 94px;
    overflow: hidden;
  }
  .demo .img-list {
    width: 180px !important;
    height: 140px !important;
  }
  .tip:last-child {
    margin-right: 2px !important;
  }
  .list-title {
    overflow: hidden;
  }
  li.item.title {
    overflow: hidden !important;
  }
  .gc-button {
    height: 31px !important;
  }
  .small-bullet.value {
    /* padding-right: 5px;
    text-align: right !important; */
  }

}
</style>
